import { useEffect, useMemo, useState } from "react";

import {
    getFoods,
} from "../services/adminApi";

import FoodHeader from "../components/food/FoodHeader";
import FoodStats from "../components/food/FoodStats";
import FoodFilterBar from "../components/food/FoodFilterBar";
import FoodTable from "../components/food/FoodTable";

import "../css/Food.css";

function Foods() {

    const [foods, setFoods] = useState([]);

    const [loading, setLoading] = useState(true);

    const [filters, setFilters] = useState({

        search: "",

        category: "",

        provider: "",

        foodType: "",

        available: "",

    });

    const loadFoods = async () => {

        try {

            setLoading(true);

            const res = await getFoods();

            setFoods(res.data.foods || []);

        } catch (error) {

            console.error("Failed to load foods:", error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadFoods();

    }, []);

    const filteredFoods = useMemo(() => {

        return foods.filter((food) => {

            const search = filters.search.toLowerCase();

            const matchesSearch =

                !search ||

                food.foodName?.toLowerCase().includes(search) ||

                food.providerId?.businessName
                    ?.toLowerCase()
                    .includes(search);

            const matchesCategory =

                !filters.category ||

                food.category === filters.category;

            const matchesProvider =

                !filters.provider ||

                food.providerId?.businessName === filters.provider;

            const matchesFoodType =

                !filters.foodType ||

                food.foodType === filters.foodType;

            const matchesAvailability =

                !filters.available ||

                String(food.isAvailable) === filters.available;

            return (

                matchesSearch &&

                matchesCategory &&

                matchesProvider &&

                matchesFoodType &&

                matchesAvailability

            );

        });

    }, [foods, filters]);

    const stats = {

        total: foods.length,

        available: foods.filter(food => food.isAvailable).length,

        unavailable: foods.filter(food => !food.isAvailable).length,

        featured: foods.filter(food => food.isFeatured).length,

        bestSeller: foods.filter(food => food.isBestSeller).length,

        specials: foods.filter(food => food.isTodaysSpecial).length,

    };

    return (

        <div className="food-page">

            <FoodHeader
                totalFoods={stats.total}
                onRefresh={loadFoods}
            />

            <FoodStats
                stats={stats}
            />

           <FoodFilterBar
    foods={foods}
    filters={filters}
    setFilters={setFilters}
/>

            <FoodTable
                foods={filteredFoods}
                loading={loading}
            />

        </div>

    );

}

export default Foods;